import Lead from 'app/models/lead';
import { showError } from 'utils/messages';
import LeadGatherModal from 'app/views/modals/lead_gather_modal';

import Base from 'app/views/base';
import tmpl from 'templates/empty';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    click: 'buttonClicked',
  },

  initialize(options) {
    this.model = new Lead({});
    this.source = options.source;
    this.user = options.user;
    this.disabled = false;
    this.leadGatherModal = new LeadGatherModal({ source: this.source });
  },

  buttonClicked(e) {
    const self = this;
    e.preventDefault();

    if (this.disabled) { return; }

    if (this.user.isLoggedIn()) {
      this.disabled = true;

      const $target = $(e.target);
      const email = self.user.get('email');

      this.model.save({ source: this.source, email }, {
        success() {
          $target
            .removeClass('btn-blue')
            .addClass('btn-success')
            .css('overflow', 'hidden')
            .css('text-overflow', 'ellipsis')
            .html(`${'<div><strong>We\'ll email you at</strong></div>' +
              '<small>'}${email}</small>`);
        },
        error() {
          showError('Unfortunately the browser was unable to communicate with the EasyPost servers, please mail support@easypost.com to get in touch!');
          self.disabled = false;
        },
      });
    } else {
      this.leadGatherModal.show();
    }
  },
});



// WEBPACK FOOTER //
// ./app/views/lead_gather_button_component.js